<script setup lang="ts">
  import { Chat, useChatStore } from '@healthpilot/acars'
  import { useChatController } from '@healthpilot/acars'

  const { path } = AppRoute.use()
  const session = SessionStore.use()
  const { flag } = FeatureFlags.use()

  const { getComponentContent } = Cms.use()
  const { content } = await getComponentContent('PxChat', 'refactor')
  const { isOpen } = useChatController()

  const hideLauncher = computed(() => flag<boolean>('hide-chat-launcher').value)
  const showGlobalStickyFooter = computed(() => flag('show-global-sticky-footer').value)

  const showLauncher = computed(
    () =>
      !hideLauncher.value &&
      !showGlobalStickyFooter.value &&
      (['/quotes', '/compare'].includes(path.value) || path.value.includes('/details'))
  )

  const { isSupportHours } = await SupportHours.use()

  const inScopeSuggestions = computed(() => [
    ...new Set(
      content.value.data
        .filter((x: any) => x.paths.some((p: string) => path.value.startsWith(p)))
        .flatMap((x: any) => x.suggestions as string[])
    )
  ])

  const chatStore = useChatStore()
  const customerMessages = computed(() =>
    chatStore.dedupedEvents.filter(
      (x) => x.participantRole === 'customer' && x.type === 'textMessage'
    )
  )

  const showSuggestions = computed(
    () =>
      inScopeSuggestions.value.length &&
      !session.chatSuggestionsUsed.length &&
      !(customerMessages.value.length > 0) &&
      isSupportHours.value
  )

  const isQuotes = computed(() => path.value === '/quotes')
</script>

<template>
  <Chat
    :class="[
      'fixed bottom-0 right-0 z-50 md:bottom-24 md:right-10',
      { 'h-full w-full md:h-[45rem] md:w-[25rem]': isOpen },
      { 'md:bottom-8': isQuotes }
    ]"
  >
    <template #suggestions>
      <slot name="suggestions">
        <PxChatSuggestions v-if="showSuggestions" :suggestions="inScopeSuggestions" />
      </slot>
    </template>
    <template #launcher="{ unreadMessages }">
      <slot name="launcher">
        <div
          class="fixed relative bottom-10 right-2 rounded-quote bg-primary-100 p-4 md:bottom-0"
          v-if="showLauncher"
        >
          <HpButton variant="secondary" @click="() => PxChat.show({ pxSource: 'quotesLauncher' })">
            <div
              v-if="unreadMessages > 0"
              class="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-danger text-white"
            >
              {{ unreadMessages }}
            </div>
            Talk to an agent
          </HpButton>
        </div>
      </slot>
    </template>
  </Chat>
</template>

<style>
  @import '/node_modules/@healthpilot/acars/dist/index.css';
</style>
